import Field from "../../../shared/ui/Field/Field";
import TextInput from "../../../shared/ui/Field/TextInput";
import Select from "../../../shared/ui/Field/Select";
import Checkbox from "../../../shared/ui/Field/Checkbox";
import InlineError from "../../../shared/ui/Field/InlineError";
import Spinner from "../../../shared/ui/Loading/Spinner";

// ClientContactRow — presentational row component. Owns NO state.
// Receives the row's full shape via props and emits change events via
// callbacks. Stable key is supplied by the parent (see
// migration/phase12-nested-array-plan.md §2.1).
//
// Phase 13 update: proto-consumer migration from a native styled
// <select> to the formal Select primitive. User-visible behaviour is
// byte-identical (the underlying .ui-select rules in ui-primitives.css
// were extracted verbatim from the prior feature-local rules).

const TYPE_OPTIONS = [
  { value: "phone", label: "Телефон" },
  { value: "email", label: "Email" },
  { value: "telegram", label: "Telegram" },
  { value: "whatsapp", label: "WhatsApp" },
];

const VALUE_MAX_LENGTH = 255;

function ClientContactRow({
  row,
  dirty,
  onChange,
  onSave,
  onCancel,
  onDelete,
}) {
  const {
    key,
    id,
    type,
    value,
    is_primary: isPrimary,
    saveState,
    deleteState,
    fieldErrors,
  } = row;

  const saving = saveState === "saving";
  const deleting = deleteState === "deleting";
  const isDraft = id == null;
  const busy = saving || deleting;

  const typeFieldId = `${key}-type`;
  const valueFieldId = `${key}-value`;
  const primaryFieldId = `${key}-is_primary`;

  const formError = fieldErrors._form;
  const saveDisabled = busy || (!isDraft && !dirty);
  const showCancel = isDraft || dirty;

  const handleTypeChange = (event) => {
    onChange(key, "type", event.target.value);
  };

  const handleValueChange = (event) => {
    onChange(key, "value", event.target.value);
  };

  const handlePrimaryChange = (event) => {
    onChange(key, "is_primary", event.target.checked);
  };

  return (
    <li className="feature-client-contacts__row" data-row-key={key}>
      <div className="feature-client-contacts__row-fields">
        <Field
          id={typeFieldId}
          label="Тип"
          error={fieldErrors.type}
          className="feature-client-contacts__field feature-client-contacts__field--type"
        >
          <Select
            name="type"
            value={type}
            onChange={handleTypeChange}
            options={TYPE_OPTIONS}
            disabled={busy}
          />
        </Field>

        <Field
          id={valueFieldId}
          label="Значення"
          error={fieldErrors.value}
          className="feature-client-contacts__field feature-client-contacts__field--value"
        >
          <TextInput
            name="value"
            type="text"
            value={value}
            onChange={handleValueChange}
            maxLength={VALUE_MAX_LENGTH}
            autoComplete="off"
            disabled={busy}
          />
        </Field>

        <div className="feature-client-contacts__field feature-client-contacts__field--primary">
          <Checkbox
            id={primaryFieldId}
            name="is_primary"
            label="Основний"
            checked={isPrimary}
            onChange={handlePrimaryChange}
            disabled={busy}
            error={fieldErrors.is_primary}
          />
        </div>
      </div>

      {formError ? (
        <div className="feature-client-contacts__row-messages">
          <InlineError className="feature-client-contacts__row-message">
            {formError}
          </InlineError>
        </div>
      ) : null}

      <div className="feature-client-contacts__row-actions">
        <button
          type="button"
          className="feature-client-contacts__save-button"
          onClick={() => onSave(key)}
          disabled={saveDisabled}
          data-loading={saving ? "true" : undefined}
        >
          {saving ? (
            <Spinner size="sm" label="Збереження" />
          ) : isDraft ? (
            "Додати"
          ) : (
            "Зберегти"
          )}
        </button>

        {showCancel ? (
          <button
            type="button"
            className="feature-client-contacts__cancel-button"
            onClick={() => onCancel(key)}
            disabled={busy}
          >
            Скасувати
          </button>
        ) : null}

        <button
          type="button"
          className="feature-client-contacts__delete-button"
          onClick={() => onDelete(key)}
          disabled={busy}
          data-loading={deleting ? "true" : undefined}
        >
          {deleting ? (
            <Spinner size="sm" label="Видалення" />
          ) : (
            "Видалити"
          )}
        </button>
      </div>
    </li>
  );
}

export default ClientContactRow;
